package org.gymly.data

import io.ktor.client.request.forms.FormBuilder
import io.ktor.http.ContentType
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import org.gymly.model.PickedImagePayload

/** Mutable holder so picker results survive Dialog coroutine timing races. */
class PickedMediaHolder {
    var payload: PickedImagePayload? = null
    var fileName: String? = null

    fun clear() {
        payload = null
        fileName = null
    }

    fun set(picked: PickedImagePayload, name: String) {
        payload = picked
        fileName = name
    }
}

internal fun FormBuilder.appendUploadFile(fieldName: String, image: PickedImagePayload) {
    val safeName = image.fileName.replace("\"", "").ifBlank { "file" }
    val mime = image.mimeType.trim().ifBlank {
        when {
            safeName.endsWith(".pdf", ignoreCase = true) -> "application/pdf"
            safeName.endsWith(".png", ignoreCase = true) -> "image/png"
            safeName.endsWith(".webp", ignoreCase = true) -> "image/webp"
            safeName.endsWith(".gif", ignoreCase = true) -> "image/gif"
            safeName.endsWith(".mp4", ignoreCase = true) -> "video/mp4"
            safeName.endsWith(".webm", ignoreCase = true) -> "video/webm"
            safeName.endsWith(".mov", ignoreCase = true) -> "video/quicktime"
            else -> "image/jpeg"
        }
    }
    append(
        key = fieldName,
        value = image.bytes,
        headers = Headers.build {
            append(HttpHeaders.ContentType, ContentType.parse(mime).toString())
            append(HttpHeaders.ContentDisposition, "filename=\"$safeName\"")
        },
    )
}
